import { IOdd } from '.';

interface IBase1x2 {
    odd1: IOdd;
    oddX: IOdd;
    odd2: IOdd;
    odd1X: IOdd;
    oddX2: IOdd;
    odd12: IOdd;
}

// 12 is in ITipList

export interface IOdds1x2 extends IBase1x2 { }

export interface IHandicap1x2 extends IBase1x2 {
    detail: string;
}

export interface ISpreadOrHandicap12 {
    rate1: IOdd;
    rate2: IOdd;
    detail: string;
}

// export interface IOddsVMT {
//     odds: IOdd[];
// }

// export interface ICorrectScore {
//     odds: IOdd[];
// }

export interface ITipList {
    items: IOdd[];
}

export interface IBelowOver {
    tips: IOdd[];
    detail: string;
}

export type IOddsType = IOdds1x2 | IHandicap1x2 | ISpreadOrHandicap12 | ITipList | IBelowOver;

export function isTipList(odds: IOddsType): odds is ITipList {
    return (<ITipList>odds).items !== undefined;
}

export function isOdds1x2(odds: IOddsType): odds is IOdds1x2 {
    return (<IOdds1x2>odds).odd12 !== undefined && (<IHandicap1x2>odds).detail === undefined;
}

export function isHandicap1x2(odds: IOddsType): odds is IHandicap1x2 {
    return (<IHandicap1x2>odds).odd12 !== undefined && (<IHandicap1x2>odds).detail !== undefined;
}

export function isBelowOver(odds: IOddsType): odds is IBelowOver {
    return (<IBelowOver>odds).tips !== undefined;
}

export function isSpreadOrHandicap12(odds: IOddsType): odds is ISpreadOrHandicap12 {
    return (<ISpreadOrHandicap12>odds).rate1 !== undefined;
}

